import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function guardarImagenGenerico(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/imagen/guardar-imagen-generico",
            API_BASE_URL + "/imagen/guardar-imagen-generico",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImagenGenerico err");
        console.log(err);
        return { error: true, message: err };
    }
}
